import axios from 'axios';

import * as types from '../types';
import services from 'services/services';
import { kioskSlug } from 'helpers'

export const getConfiguration  = () => async (dispatch) => {
	try {
		dispatch({
			type: types.CONFIGURATION_FETCH_DATA_LOADING
		});

		const kioskUrl = `/v1/kiosk/${kioskSlug}/preview`;
		const airportListUrl = '/v1/airport/collection'
		const { data: {data: {airports, uuid, details: {type}}} } = await services.get(kioskUrl);
		const airport = airports[Object.keys(airports)[0]];
		const { data: {data: airportList} } = await services.get(airportListUrl);
		dispatch({
			type: types.CONFIGURATION_FETCH_DATA_SUCCESS,
			payload: {
				type,
				kioskUuid: uuid,
				cityName: airport.city,
				airportUuid: airport.uuid,
				airportLocation: airport.location,
				airportList: airportList
			}
		});
	} catch (error) {
		if (axios.isCancel(error)) {
			return;
		}

		dispatch({
			type: types.CONFIGURATION_FETCH_DATA_ERROR,
			payload: error
		});
	}
};
